import { Component, Input, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-common-text',
  templateUrl: './common-text.component.html',
  styleUrls: ['./common-text.component.css']
})
export class CommonTextComponent implements OnInit {

  @Input()
  set widgetData(value: any) {
    this._widgetData = value;
    this.valueReplaceList = this._widgetData?.dataAttributes?.value;
  }

  get widgetData() {
    return this._widgetData;
  }

  @Input() entityId: string;

  @Input() entityDetails: any;

  // Data
  attributeValue: string = null;
  attributeColor: string;
  valueReplaceList: any[];
  isloader: boolean = true;
  isError: boolean = false;
  private _widgetData: any;

  // API Refresh
  private _intervalTimer: any;

  // Subscription
  private _entityAttributeValueSubscription: Subscription;

  constructor(
    private _service: EntitiesServiceService
  ) { }

  ngOnInit(): void {
    this._getEntityAttributeValue();
    this._refreshApi();
  }

  ngOnDestroy(): void {
    this._entityAttributeValueSubscription?.unsubscribe();
    this._clearTimer();
  }

  /**
   * Gets entity attribute value
   */
  private _getEntityAttributeValue() {
    const payload = {
      attributes: [this.widgetData?.dataAttributes?.attributeName],
      entityId: this.entityId
    }
    this._entityAttributeValueSubscription = this._service.entityAttributeValue(payload).subscribe(
      {
        next: (result: any) => {
          this.attributeValue = result?.length ? result?.[0]?.value : null;
          this.attributeColor = this._getAttributeColor(this.attributeValue);
          this.isloader = false;
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
          }
        }
      }
    )
  }

  /**
   * Gets attribute color
   * @param value 
   * @returns attribute color 
   */
  private _getAttributeColor(value: string): string {
    return this.valueReplaceList?.length ? this.valueReplaceList?.find(item => item?.value === value)?.color : '';
  }

  /**
   * Refreshs api
   */
   private _refreshApi() {
    if (+this.widgetData?.attributes?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._getEntityAttributeValue();
      }, +this.widgetData?.attributes?.refreshRate);
    }
  }

  /**
   * Clears timer
   */
  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }
}
